import { CSSProperties, forwardRef, ReactNode, useEffect } from 'react';
import { css, cx } from '@linaria/atomic';
import { motion, AnimatePresence, MotionProps } from 'motion/react';
import { theme } from '@frontend/theme';
import { useTabbable, useRefInterceptor } from '../../hooks';
import { DialogFlyoutProps } from './types';

const flyoutDialogStyle = css`
  background: ${theme.colors.white};
  box-shadow: ${theme.shadows.heavy};
  position: absolute;

  &:focus {
    outline: none;
  }
`;

type Props = DialogFlyoutProps<HTMLDivElement> &
  MotionProps & {
    disableAutofocus?: boolean;
    children: ReactNode;
    style?: CSSProperties;
    className?: string;
  };

/**
 *
 * @deprecated use PopoverDialog instead
 */
export const FlyoutDialog = forwardRef<HTMLElement, Props>(
  ({ disableAutofocus, children, className, ...rest }, ref) => {
    const [localRef, elementRef] = useRefInterceptor(ref);

    useTabbable({ ref: localRef });
    useEffect(() => {
      if (!disableAutofocus) {
        setTimeout(() => {
          localRef.current?.focus();
        }, 0);
      }
    }, [disableAutofocus, localRef]);

    return (
      <AnimatePresence>
        <motion.div className={cx(flyoutDialogStyle, className)} {...rest} ref={elementRef}>
          {children}
        </motion.div>
      </AnimatePresence>
    );
  }
);

FlyoutDialog.displayName = 'FlyoutDialog';
